__turbopack_context__.v({
  "hidden": "bonus-conversion-widget-module-scss-module__JqETSW__hidden",
  "root": "bonus-conversion-widget-module-scss-module__JqETSW__root",
  "rootWrapper": "bonus-conversion-widget-module-scss-module__JqETSW__rootWrapper",
});
